// extracted by css-extract-rspack-plugin
export default {"root":"YyiWM5FHh1shUc8O","icon":"WZpR1j4OBKwgmi2j","content":"IVfoQRMcuZUAxFAu"};